export default "__VITE_ASSET__iH_1DI8N__"